import React from 'react';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import Rule from 'bento-ordering/base/ui_components/Rule';

/* this container displays a rule only on mobile */

const RuleContainer = ({ children }) => {
  const theme = useTheme();
  const isMediumAndUp = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <Box position="relative">
      {!isMediumAndUp && <Rule />}
      {children}
    </Box>
  );
};

RuleContainer.propTypes = {
  children: CHILDREN_PROP_TYPES
};

export default RuleContainer;
